<template>
	<div>
		<el-dialog title="激活码兑换" :visible.sync="openVipVisible" width="500px">
			<el-form ref="formVip" :model="formVip" label-width="80px" :rules="rules">
				<el-form-item label="会员号：" prop="memberCode">
					<el-input v-model="formVip.memberCode" placeholder="请输入会员号"></el-input>
				</el-form-item>
				<el-form-item label="激活码：" prop="memberPassword">
					<el-input v-model="formVip.memberPassword" placeholder="请输入激活码"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit" class="marginRight15">确定</el-button>
					<el-button @click="openVipVisible = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import { boundMember, currentStudent } from '@/api/login'
import { dictList } from '@/api/college'
export default {
	name: "update-info",
	data() {
		return {
			openVipVisible: false,
			rules: {
				memberCode: [
					{ required: true, message: '请输入会员号', trigger: 'blur' },
				],
				memberPassword: [
					{ required: true, message: '请输入激活码', trigger: 'blur' },
				],
			},
			formVip: {},

		}
	},
	methods: {
		init(){
			this.formVip = {}
			this.openVipVisible = true
		},
		onSubmit() {
			this.$refs['formVip'].validate((valid) => {
				if (valid) {
					boundMember(this.formVip).then(async res => {
						if (res && res.code == 200) {
							this.$message({
								message: '激活成功',
								type: 'success'
							});
							let user = await currentStudent();
							if(user && user.code == 200){
								this.ruleForm = user.data
								this.$store.commit("UPDATE_STUDENT", user.data)
							}
							this.openVipVisible = false
						}
					})
				} else {
					return false;
				}
			});

		},
	}
}
</script>

<style lang="less">
/* 隐藏 el-cascader 最后一层选项的箭头 */
.el-cascader-panel .el-scrollbar__bar {
	display: none;
}
</style>